module.exports = __webpack_public_path__ + "img/img24.d4298823.svg";